/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Refresh_Token_InvalidInputs */

const en_us2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not continue your session. Sign in again.`)
};

const pt_br2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível continuar sua sessão. Entre novamente.`)
};

const es_419_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos continuar tu sesión. Inicia sesión de nuevo.`)
};

const pt_pt2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível continuar a tua sessão. Inicia sessão novamente.`)
};

const fr_fr2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de poursuivre ta session. Reconnecte-toi.`)
};

const de_de2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Sitzung konnte nicht fortgesetzt werden. Melde dich erneut an.`)
};

const it_it2_auth_refresh_token_invalid = /** @type {(inputs: Auth_Refresh_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile continuare la tua sessione. Accedi di nuovo.`)
};

/**
* | output |
* | --- |
* | "We could not continue your session. Sign in again." |
*
* @param {Auth_Refresh_Token_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_refresh_token_invalid = /** @type {((inputs?: Auth_Refresh_Token_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Refresh_Token_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_refresh_token_invalid(inputs)
	if (locale === "es-419") return es_419_auth_refresh_token_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_refresh_token_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_refresh_token_invalid(inputs)
	if (locale === "de-DE") return de_de2_auth_refresh_token_invalid(inputs)
	if (locale === "it-IT") return it_it2_auth_refresh_token_invalid(inputs)
	return en_us2_auth_refresh_token_invalid(inputs)
});
export { auth_refresh_token_invalid as "auth.refresh_token_invalid" }